/**
 * Element UI 确认框封装
 * @param {String} content 提示内容（必填）
 * @param {String} type 提示类型，默认 warning
 * @param {String} title 标题，默认 提示
 * @param {String} confirmText 确认按钮文字，默认 确定
 * @param {String} cancelText 取消按钮文字，默认 取消
 * @returns {Promise} Promise 对象
 */
import Vue from 'vue'
import Element from 'element-ui'
Vue.use(Element)
export const confirmDialog = ({
  content,
  type = 'warning',
  title = '提示',
  confirmText = '确定',
  cancelText = '取消'
}) => {
  // 优先使用当前方法的this（组件实例），其次用window.vm
  const vm = this || window.vm || {}

  // 校验核心方法是否存在，避免执行失败
  if (!vm.$confirm) {
    console.error('Element UI 的 $confirm 方法未找到，请检查Element UI是否正确引入！')
    // 返回rejected的Promise，让调用方catch能捕获到明确错误
    return Promise.reject(new Error('$confirm 方法不存在'))
  }

  return new Promise((resolve, reject) => {
    vm.$confirm(content, title, {
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      type: type
    }).then(() => {
      // 点击确定
      resolve()
    }).catch((err) => {
      // 区分「用户取消」和「执行错误」
      if (err === 'cancel' || err === 'close') {
        // 用户主动取消/关闭弹窗，属于正常取消
        reject('cancel')
      } else {
        // 真正的执行错误，打印日志便于排查
        console.error('确认框执行出错：', err)
        reject(err)
      }
    })
  })
}